import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { AreaI } from "interfaces/Area";
import { Dropdown } from "react-bootstrap";
import { deleteArea } from "services/area";

interface Props {
  elemento: AreaI;
  onClickEdit: (elemento: AreaI) => void;
  refreshTable: () => void;
}

export const AreaRowActions = ({
  elemento,
  onClickEdit,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteArea(id);
      showSuccessToast("¡El área fue eliminada con éxito!");
      refreshTable();
    } catch (error:any) {
      showErrorToast("Error eliminando el área: ", error.message);
    }
  };

  // const onClickVerDocumento = (id: string | number) => {
  //     openFile({ id })
  // }

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar resolución"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar el Área {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
